<template>
  <div class="box">
    <div class="box-header">
      <h3>Ordered By</h3>
    </div>
    <div class="box-body">
      <ul>
        <li :class="[{ 'active': i.isSelect }]" v-for="(i, index) in allEmail" :key="index"
          @click="setOwner(index, i.email)">{{ i.email }}</li>
      </ul>
      <p v-if="error" style="color:red">{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['info', 'edit', 'error'],
  data: () => ({
    allEmail: [],
    selectOwner: []
  }),
  methods: {
    setOwner(index, email) {
      const isFind = this.selectOwner.find((f) => f === email)
      if (isFind) {
        this.allEmail.forEach((item, index) => {
          if (item.email === email) this.allEmail[index].isSelect = false
        })
        this.selectOwner.forEach((i, ind) => {
          if (i === email) this.selectOwner.splice(ind, 1);
        })
      } else {
        this.allEmail.forEach((item, index) => {
          if (item.email === email) this.allEmail[index].isSelect = true
        })
        this.selectOwner.push(email)
      }
    }
  },
  watch: {
    "info": {
      handler(value) {
        if (value.length) {
          this.allEmail = []
          this.selectOwner = []
          this.allEmail = value.map((i) => {
            let isSelect = false
            if (i.isOwner) {
              isSelect = true
              this.selectOwner.push(i.email)
            }
            return {
              email: i.email,
              isSelect
            }
          });
        }
      },
      immediate: true,
      deep: true
    },
    "edit": {
      handler(value) {
        this.selectOwner = []
        this.allEmail = value.map((i) => {
          this.selectOwner.push(i)
          return {
            email: i,
            isSelect: true
          }
        });
      },
      immediate: true,
      deep: true
    },
    selectOwner: {
      handler(val) {
        if (val.length) {
          this.$emit("input", val);
        }
      },
      immediate: true,
      deep: true,
    },
  }
};
</script>


<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 10px;

  li {
    margin: 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: var(--light-grey-color);
    padding: 0 20px;
    height: 2.5rem;
    border-radius: var(--radius);
    font-size: var(--sm-font);

    &.active {
      background-color: rgba(var(--primary-color-rgb), 0.09);
      color: var(--primary-color) !important;
      border: 2px solid var(--primary-color);
    }
  }
}
</style>
